import createCustomEvent from '/druid/createCustomEvent';

export default function createErrorEvent(error) {
  return createCustomEvent('error', { error });
}
